import React from "react";
import { Col, Row } from "react-bootstrap";
//import { CgCPlusPlus } from "react-icons/cg";
import {
 // DiJavascript1,
 // DiReact,
 // DiNodejs,
 // DiMongodb,
  DiPython,
  DiGit,
  //DiJava,
} from "react-icons/di";
import {
  SiMysql,
  SiPowerbi,
  SiMicrosoftexcel,
  
 // SiRedis,
  //SiFirebase,
  //SiNextdotjs,
 // SiSolidity,
} from "react-icons/si";
//import { TbBrandGolang } from "react-icons/tb";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPowerbi />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMicrosoftexcel />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPython />
      </Col>
    </Row>
  );
}

export default Techstack;
